<template>
  <div>
    <div v-if="youtubeData && youtubeData.videoId" class="youtube-player-block">
        <youtube-player class="youtube-player" v-slot="{loadPlayer}" :video-id="youtubeData.videoId" 
        :autoload="true" :auto-play="false" :aspect-ratio="youtubeData.aspectRatio" transcriptHeader="">
            <button class="youtube-player__poster" type="button" @click="loadPlayer" @keypress.space="loadPlayer"
                @keypress.enter="loadPlayer">
                <picture class="picture has-aspect-ratio" :class="youtubeData.aspectRatio" >               
                    <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" :data-src="youtubeData.youtubeThumbnailImage"  class="lazy" decoding="async" />
                </picture>
                <span class="button-pills --small-icon">
                     <svg aria-hidden="true" class="icon">
                         <use xlink:href="#play" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                     </svg> <span class="is-sr-only">Play the video {{ youtubeData.videoTitle }}</span>
                 </span>
            </button>
        </youtube-player>
    </div>
    <div v-else-if="videoData && videoData.src" class="video-block has-aspect-ratio" v-lazy-load-video>	
        <video-block  :video-data="videoData"></video-block>
    </div>
    <div  v-else class="image-block has-aspect-ratio">
        <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" :data-src="pictureData.Src" class="lazy articlepicture" :alt="pictureData.Alt">
    </div>
  </div>
</template>
<script>

export default {
    name:"all-media-block", 
    data() {
        return {
            isDesktop: window.innerWidth >= 1024,
            videoData: {},
            pictureData: {},
            youtubeData: {}
        };
    },
    props: {
        mediaBlock :{
            type: Object,
            required: true
        }
    },
    created() {
        this.checkScreenSize();
        window.addEventListener('resize', this.checkScreenSize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize);
    },
    methods: {
        checkScreenSize() {
            this.isDesktop = window.innerWidth >= 1024;
            if(this.isDesktop) {
                this.videoData = this.mediaBlock.videoFileDesktop;
                this.pictureData = this.mediaBlock.pictureDesktop;
            }else { 
                let videoDataMobile = this.mediaBlock.videoFileMobile;
                let pictureMobile = this.mediaBlock.pictureMobile;
                this.videoData =  (videoDataMobile == null || videoDataMobile.src == "") ? this.mediaBlock.videoFileDesktop : this.mediaBlock.videoFileMobile;
                this.pictureData = (pictureMobile == null || pictureMobile.Src == "") ? this.mediaBlock.pictureDesktop : this.mediaBlock.pictureMobile;
            }
            this.youtubeData = this.mediaBlock.youtubeFile;
        },
    }
}
</script>